<template>
  <div class="investment_warp">
    <SearchHunt
      :filterData="filterData"
      @handle_seach="handle_seach"
      ref="SearchHunt"
    />
    <a-table
      class="antd-table"
      bordered
      :columns="relevanceBatch_grid.field"
      :data-source="relevanceBatch_grid.row"
      :rowKey="(record, index) => { return index;}"
      size="small"
      :scroll="{ y: relevanceBatch_grid.height,x:relevanceBatch_grid.width}"
      :pagination="false"
      :loading="tableLoading"
    > 
      <div slot="index" slot-scope="text, record, index">
        {{ index + (pageParam.pageNum - 1) * pageParam.pageSize + 1 }}
      </div>
      <!-- 更多操作 -->
      <span slot="operation" slot-scope="data" class="ellipsis">
        <a @click="handle_operation(data,1)">充值</a>
        <a @click="handle_operation(data,2)">退费</a>
      </span>
    </a-table>

    <!-- 底部 -->
    <div class="table_bottom">

      <!-- 分页 -->
      <div>
        <a-pagination
          class="table_pagination"
          show-size-changer
          :default-current="1"
          v-model="pageParam.pageNum"
          :show-total="(total) => `共 ${total} 条`"
          :page-size-options="pageSizeOptions"
          size="small"
          :total="total"
          @showSizeChange="onShowSizeChange"
          @change="paginationChange"
          :page-size.sync="pageParam.pageSize"
        />
      </div>
    </div>

    <!-- 表单 -->
    <!-- 添加 -->
    <addModal
      v-if="addVisible"
      :modalTitle="addModalTitle"
      :accountNo="accountNo"
      :detailId="detailId"
      :type="type"
      @close="close" 
      @handleOk="addlHandleOk"
    ></addModal>
  </div>
</template>

<script>
import {  getId,queryAccountList} from "@/api/api.js";
import SearchHunt from "./components/search-hunt/search-hunt.vue";
import addModal from "./components/modal-hunt/add-modal.vue";
export default {
  name: "",
  components: {
    SearchHunt,
    addModal
  },
  data() {
    return {
      //搜索栏
      filterData: [
        {
          name: "accountNo",
          type: "input",
          value: undefined,
          label: "请输入账户编号",
          placeholder:"账户编号：",
        },
        {
          name: "accountName",
          type: "input",
          value: undefined,
          label: "请输入账户名称",
          placeholder:"账户名称：",
        },
      ],
      relevanceBatch_grid: {
        height: "calc(100vh - 250px)",
        width: 0, // 宽度
        row: [],
        field: [
          {
            title: "序号",
            align: "center",
            dataIndex: "index",
            width: 50,
            key: "index",
            ellipsis: true,
            scopedSlots: { customRender: "index" },
          },
          {
            title: "账户编号",
            align: "center",
            width: 110,
            dataIndex: "accountNo",
            ellipsis: true,
          },
          {
            title: "账户姓名",
            align: "center",
            width: 110,
            dataIndex: "accountName",
            ellipsis: true,
          },
          {
            title: "账户余额",
            align: "center",
            width: 100,
            dataIndex: "accountAmount",
            ellipsis: true,
          },
          {
            title: "累计充值金额",
            align: "center",
            width: 100,
            dataIndex: "rechargeAmount",
            ellipsis: true,
          },
          {
            title: "累计消费额",
            colSpan: 1,
            width: 100,
            dataIndex: "accumConsume",
            align: "center",
            ellipsis: true,
          },
          {
            title: "累计退费额",
            colSpan: 1,
            align: "center",
            width: 100,
            ellipsis: true,
            dataIndex: "returnAmount",
          }, 
          {
            title: "最后消费日期",
            colSpan: 1,
            align: "center",
            width: 120,
            ellipsis: true,
            dataIndex: "recentConsumeDate",
          },
          {
            title: "操作",
            width: 100,
            align: "center",
            scopedSlots: {
              customRender: "operation",
            },
          },
        ]
      },
      pageParam: {
        pageNum: 1,
        pageSize: 10,
        orderBy: ""
      },
      pageSizeOptions: ["10", "20", "50", "100"],
      total: 0,
      paramsObj: {
        accountName: null,
        accountNo:null,
      },
      //添加弹窗
      addVisible: false,
      addModalTitle: "",
      accountNo: "",
      type:"",
      //查询加载
      tableLoading:false,
      detailId:""
    };
  },
  mounted() {
      //查询
    this.queryList();
    this.relevanceBatch_grid.width = 0;
    this.relevanceBatch_grid.field.map(item => {
      this.relevanceBatch_grid.width += item.width;
    });
  },
  methods: {
    paginationChange(page, pageSize) {
      this.pageParam.pageNum = page;
      this.queryList();
    },
    onShowSizeChange(current, size) {
      this.pageParam.pageSize = size;
      this.pageParam.pageNum = 1;
      this.queryList();
    },
    // 查询
    handle_seach(params) {
      this.paramsObj = params;
      this.pageParam.pageNum = 1;
      this.queryList();
    },
    queryList() {
      this.tableLoading = true;
      queryAccountList({
        pageParam: {
          pageNum: this.pageParam.pageNum,
          pageSize: this.pageParam.pageSize,
          orderBy: ""
        },
        content: this.paramsObj
      })
      .then((res) => {
        if (res.content.rows && res.content.rows.length) {
          this.relevanceBatch_grid.row = res.content.rows;
          this.total = res.content.page.totalRows;
        } else {
          this.relevanceBatch_grid.row = [];
          this.total = 0;
        }
        this.tableLoading = false;
      }, (err) => {
        this.tableLoading = false;
      });
    },
    //充值/退款
    handle_operation(data, type) {
      getId().then((res) => {
        this.detailId = res.content.id;
        if (type == 1) {
          this.accountNo = data.accountNo;
          this.type = '1';
          this.addModalTitle = "账户充值";
          this.addVisible = true;
        } else if (type == 2) {
          this.accountNo = data.accountNo;
          this.type = '2'
          this.addModalTitle = "账户退款"; 
          this.addVisible = true;
        } 
      })
    },
    //弹窗关闭
    close() {
      this.addVisible = false;
    },
    //添加弹窗确认
    addlHandleOk() {
      this.queryList();
      this.addVisible = false;
    },
  },
};
</script>

<style scoped lang="less">
.select_width {
  width: 180px !important;
}
.ellipsis {
  display: inline-block;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.investment_flex {
  display: flex;
  margin-bottom: 15px;
}
.investment_li {
  margin-right: 15px;
}
.custom {
  margin: 5px;
  color: #4093e1;
  cursor: pointer;
}
.table_pagination {
  margin-top: 15px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.box_warp {
  overflow-y: auto;
}
.end {
  justify-content: flex-end;
}
.sp_name {
  display: inline-block;
  font-size: 20px;
  margin: 10px 0px;
  margin-bottom: 20px;
  padding: 0 5px;
  border-left: 5px solid #0b2464;
}

.table_bottom{

  .bottom_btn{
    margin-top: 10px;

    .btn_first{
      margin-right: 10px;
    }
  }
}
</style>